<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="窗口期" prop="windowTime">
                <el-date-picker v-model="queryCondition.windowTime" type="month" value-format="yyyy-MM" format="yyyy-MM" placeholder="选择月"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="窗口期名称" prop="windowName">
                <el-input v-model="queryCondition.windowName" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态" prop="status">
                <ic-select table="TM_NUTR_INSPECT_WINDOW" field="STATUS" clearable v-model="queryCondition.status" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <!-- <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span> -->
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onAdd" v-acl="NUTR_INSPECT_WINDOW_ADD">新增窗口期</el-button>
      </el-row>
      <el-row>
        <el-table :data="tableData" max-height="425" border stripe style="width: 100%">
          <!-- <el-table-column prop="windowTime" sortable="custom" label="窗口期" width="180"></el-table-column>
          <el-table-column prop="windowName" :sort-method="sortMethods" sortable="custom" label="窗口期名称" width="180"></el-table-column>
          <el-table-column prop="startDate" sortable="custom" label="开始日期"></el-table-column>
          <el-table-column prop="sampleEndDate" sortable="custom" label="送样截至日期"></el-table-column>
          <el-table-column prop="inspectEndDate" sortable="custom" label="检测截至日期"></el-table-column>
          <el-table-column prop="remark" sortable="custom" label="备注"></el-table-column>
          <el-table-column prop="statusI18n" sortable="custom" label="状态"></el-table-column> -->
          <el-table-column v-for="(item, index) in columns" :key="index" :prop="item.prop" :label="item.label" sortable :sort-method="(a,b) => sortMethods(a ,b , item.prop)" :min-width="item.width"></el-table-column>
          <el-table-column prop="address" label="操作" min-width="150">
            <template slot-scope="scope">
              <el-button @click="onEdit(scope.row)" type="text" size="small" v-acl="NUTR_INSPECT_WINDOW_EDIT" v-if="scope.row.status==='NOT_START'">编辑</el-button>
              <el-button @click="onDel(scope.row)" :disabled="isDelDisabled" :loading="isDelLoading" type="text" size="small" v-acl="NUTR_INSPECT_WINDOW_DELETE" v-if="scope.row.status==='NOT_START'">删除</el-button>
              <el-button @click="onOpen(scope.row)" :disabled="isOpenDisabled" :loading="isOpenLoading" type="text" size="small" v-acl="NUTR_INSPECT_WINDOW_START_TASK" v-if="scope.row.status==='NOT_START'">开启任务</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
          </el-pagination>
        </div>
      </el-row>
      <el-dialog title="Nutrition检测窗口期" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" @close="onClose">
        <el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="检测窗口期" prop="windowTime">
            <el-date-picker v-model="addForm.windowTime" type="month" value-format="yyyy-MM" format="yyyy-MM" :picker-options="pickerMonthOptions" placeholder="选择月" style="width:100%"></el-date-picker>
          </el-form-item>
          <el-form-item label="窗口期名称" prop="windowName">
            <el-input v-model="addForm.windowName"></el-input>
          </el-form-item>
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker v-model="addForm.startDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" :picker-options="pickerStartOptions" style="width:100%"></el-date-picker>
          </el-form-item>
          <el-form-item label="送样截至日期" prop="sampleEndDate">
            <el-date-picker v-model="addForm.sampleEndDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" :picker-options="pickerEndOptions" style="width:100%"></el-date-picker>
          </el-form-item>
          <el-form-item label="检测截至日期" prop="inspectEndDate">
            <el-date-picker v-model="addForm.inspectEndDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" :picker-options="pickerInsEndOptions" style="width:100%"></el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="addForm.remark" type="textarea" :rows="2" maxlength="500" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center">
          <el-button size="mini" class="btn" type="primary" @click="onSave" :disabled="isSaveDisabled" :loading="isSaveLoading">保存</el-button>
          <el-button size="mini" class="btn" type="primary" @click="onClose">取消</el-button>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import nutriApi from "@/api/Nutrition/index";
import paginationMixin from '@/mixins/pagitionMixin';
// import { fileService } from "@/api/common/file-utils";
// import store from '@/store/index'
import IcSelect from "@/components/common/icSelect";
export default {
  name: 'Window',
  mixins: [paginationMixin],
  components: { IcSelect },
  data() {
    var validateSampleEndDate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择送样截至日期'));
      } else {
        var startM = Date.parse(new Date(this.addForm.startDate))
        var selM = Date.parse(new Date(value))
        if (selM < startM || selM == startM) {
          callback(new Error('送样截至日期需大于检测开始日期'));
        } else {
          callback();
        }
      }
    };
    var validateInspectEndDate = (rule, value, callback) => {
      if (value) {
        var startM = Date.parse(new Date(this.addForm.startDate))
        var selM = Date.parse(new Date(value))
        if (selM < startM || selM == startM) {
          callback(new Error('检测截至日期需大于检测开始日期'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var validateWindowTime = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择检测窗口期'));
      } else {
        var selM = new Date(value).getMonth() + 1
        var startM = new Date(this.addForm.startDate).getMonth() + 1
        if (this.addForm.startDate && selM != startM) {
          callback(new Error('检测窗口期与检测开始日期必须为相同月份，请更新!'));
        } else {
          callback();
        }
      }
    };
    var validateStartDate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择开始日期'));
      } else {
        var selM = new Date(value).getMonth() + 1
        var startM = new Date(this.addForm.windowTime).getMonth() + 1
        if (this.addForm.windowTime && selM != startM) {
          callback(new Error('检测窗口期与检测开始日期必须为相同月份，请更新!'));
        } else {
          callback();
        }
      }
    };
    return {
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        windowTime: "",
        windowName: "",
        status: "",
      },
      totalCount: 0,
      pages: 1,
      isShow: false,
      dialogVisible: false,
      isDelDisabled: false,
      isDelLoading: false,
      isOpenDisabled: false,
      isOpenLoading: false,
      isSaveDisabled: false,
      isSaveLoading: false,
      proptype: "",
      columns: [
        {
          prop: "windowTime",
          label: "窗口期",
          width: "150",
        },
        {
          prop: "windowName",
          label: "窗口期名称",
          width: "180",
        },
        {
          prop: "startDate",
          label: "开始日期",
          width: "150",
        },
        {
          prop: "sampleEndDate",
          label: "送样截至日期",
          width: "150",
        },
        {
          prop: "inspectEndDate",
          label: "检测截至日期",
          width: "150",
        },
        {
          prop: "remark",
          label: "备注",
          width: "180",
        },
        {
          prop: "statusI18n",
          label: "状态",
          width: "100",
        }
      ],
      tableData: [],
      addForm: {
        windowTime: "",
        windowName: "",
        startDate: "",
        sampleEndDate: "",
        inspectEndDate: "",
        remark: "",
      },
      pickerMonthOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 1 * 24 * 60 * 60 * 1000;;
        },
      },
      pickerStartOptions: {
        disabledDate(time) {
          return time.getTime() < new Date().getTime() - 1 * 24 * 60 * 60 * 1000;//减去一天的时间代表可以选择同一天;
        },
      },
      pickerEndOptions: {
        disabledDate(time) {
          return time.getTime() < new Date().getTime() - 1 * 24 * 60 * 60 * 1000;//减去一天的时间代表可以选择同一天;
        },
      },
      pickerInsEndOptions: {
        disabledDate(time) {
          return time.getTime() < new Date().getTime() - 1 * 24 * 60 * 60 * 1000;//减去一天的时间代表可以选择同一天;
        },
      },
      addFormRules: {
        windowTime: [
          { required: true, validator: validateWindowTime, trigger: 'change' }
        ],
        startDate: [
          { required: true, validator: validateStartDate, trigger: 'change' },
        ],
        sampleEndDate: [
          { required: true, validator: validateSampleEndDate, trigger: 'change' },
        ],
        inspectEndDate: [
          { validator: validateInspectEndDate, trigger: 'change' },
        ],
      }
    };
  },
  // watch: {
  //   queryCondition() {
  //     let _this = this;
  //     store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
  //   }
  // },
  // beforeRouteEnter(to, from, next) {
  //   nutriApi.findListPage(to.meta.reqData).then((res) => {
  //     next(vm => {
  //       vm.queryCondition = to.meta.reqData;
  //       vm.tableData = res.data.records;
  //       vm.totalCount = res.data.total;
  //     })
  //   })
  // },
  mounted() {
    this.queryData()
  },
  methods: {
    queryData() {
      nutriApi.findListPage(this.queryCondition).then((res) => {
        console.log("🚀 ~ file: detectionWindowPeriod.vue:135 ~ nutriApi.findListPage ~ res:", res)
        if (res.code === '200') {
          this.tableData = res.data.records
          this.totalCount = res.data.total
        }
      })
    },
    onAdd() {
      this.dialogVisible = true
      this.$refs['addForm'].resetFields();
      delete this.addForm.templateHeaderId
      delete this.addForm.inspectWindowId
    },
    onOpen(row) {
      this.isOpenDisabled = true
      this.isOpenLoading = true
      nutriApi.startTask({}, row.inspectWindowId).then((res) => {
        console.log("🚀 ~ file: detectionWindowPeriod.vue:218 ~ nutriApi.startTask ~ res:", res)
        this.isOpenDisabled = false
        this.isOpenLoading = false
        if (res.code === '200') {
          this.$message({
            type: 'success',
            message: '开启任务成功!'
          });
          this.queryData()
        }
      }).catch(error => {
        this.isOpenDisabled = false
        this.isOpenLoading = false
      })
    },
    onEdit(row) {
      nutriApi.getInspectWindow(row.inspectWindowId).then((res) => {
        console.log("🚀 ~ file: detectionWindowPeriod.vue:219 ~ nutriApi.getInspectWindow ~ res:", res)
        if (res.code === '200') {
          this.dialogVisible = true
          this.addForm = res.data
        }
      })
    },
    onDel(row) {
      this.$confirm('请确认是否删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.isDelDisabled = true
        this.isDelLoading = true
        nutriApi.deleteInspectWindow({}, row.inspectWindowId).then((res) => {
          console.log("🚀 ~ file: detectionWindowPeriod.vue:226 ~ nutriApi.deleteInspectWindow ~ res:", res)
          this.isDelDisabled = false
          this.isDelLoading = false
          if (res.code === '200') {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.queryData()
          }
        })
      }).catch(() => {
        this.isDelDisabled = false
        this.isDelLoading = false
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onSave() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.isSaveDisabled = true
          this.isSaveLoading = true
          nutriApi.saveInspectWindow(this.addForm).then((res) => {
            console.log("🚀 ~ file: detectionWindowPeriod.vue:240 ~ nutriApi.saveInspectWindow ~ res:", res)
            this.isSaveDisabled = false
            this.isSaveLoading = false
            if (res.code === '200') {
              this.$message.success('保存成功')
              this.onClose()
              this.queryData()
            }
          }).catch(error => {
            console.log("🚀 ~ error.response:", error.response)
            this.isSaveDisabled = false
            this.isSaveLoading = false
          })
        }
      })
    },
    onSearch() {
      this.queryCondition.pageNum = 1;
      this.queryData()
    },
    onReset() {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        windowTime: "",
        windowName: "",
        status: "",
      }
      this.queryData()
    },
    sortMethods(a, b, proptype) {
      console.log("🚀 ~ file: detectionWindowPeriod.vue:377 ~ sortMethods ~ proptype:", proptype)
      // console.log("🚀 ~ file: ingredient.vue:401 ~ sortMethods ~ b:", b)
      // console.log("🚀 ~ file: ingredient.vue:401 ~ sortMethods ~ a:", a)
      var prop
      if (proptype==='startDate') {
        prop='startDateMiss'
      }else if(proptype==='sampleEndDate'){
        prop='sampleEndDateMiss'
      }else if(proptype==='inspectEndDate'){
        prop='inspectEndDateMiss'
      }else{
        prop=proptype
      }
      if (a[prop] === null || a[prop] === undefined) {
        return 1; // 将空值排在后面
      } else if (b[prop] === null || b[prop] === undefined) {
        return -1; // 将空值排在后面
      } else {
        // 自定义排序逻辑
        // return a[prop] - b[prop]; // 示例中使用数字类型的比较
        if (typeof a[prop] === 'string' && typeof b[prop] === 'string') {
          return a[prop].localeCompare(b[prop])
        } else {
          return a[prop] - b[prop];
        }
      }
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onClose() {
      this.dialogVisible = false
      this.$refs['addForm'].resetFields();
    },
  }
}
</script>
  